import React, { Component } from "react";
import {
  Row,
  Col,
  Container,
  Label,
  Button,
} from "reactstrap";

import { Link } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

class ForgetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    //meta title
    document.title =
      "Forgot Password | Skote - React Admin & Dashboard Template";
    return (
      <React.Fragment>
        <Container fluid className="main-login-flow">
          <Row className="px-lg-0 px-md-5 px-2">
            <Col xl={4} lg={12} className="offset-xl-2 mt-1">
              <div className="logo-main">
                <span className="text-white login-flow-logo fs-2 fw-bold d-inline-block">
                  LOGO
                </span>
              </div>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  email: (this.state && this.state.email) || "",
                  otp: (this.state && this.state.otp) || "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string().required("Please Enter Valid Password"),
                  otp: Yup.string().required("Please Enter OTP number"),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched }) => (
                  <Form>
                    <h1 className="text-primary-light fw-bold pt-md-5 login-flow-h1">
                      Forgot Password
                    </h1>
                    <p className="login-flow-p pt-2 pb-2">
                      Enter your email to reset password
                    </p>
                    <div className="mt-2">
                      <Label
                        for="email"
                        className="form-label d-block pb-2 fw-bold login-flow-lable"
                      >
                        E-Mail
                      </Label>
                      <Field
                        name="email"
                        placeholder="Enter email"
                        type="email"
                        className={
                          "form-control py-1 py-md-3 fs-4" +
                          (errors.email && touched.email ? " is-invalid" : "")
                        }
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="mt-2">
                      <Label
                        for="otp"
                        className="form-label d-block pb-2 fw-bold login-flow-lable"
                      >
                        OTP
                      </Label>
                      <Field
                        name="otp"
                        placeholder="************"
                        type="number" onWheel={(e) => e.target.blur()}
                        className={
                          "form-control py-1 py-md-3 fs-4" +
                          (errors.otp && touched.otp ? " is-invalid" : "")
                        }
                      />
                      <ErrorMessage
                        name="otp"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    <p className="d-block text-lg-end pt-2 fs-5">
                      <a href="#" className="text-dark fw-bold">                        
                        Resend OTP
                      </a>
                    </p>

                    <div className="mt-0 mt-md-5">
                      <Link to="/newpass">
                        <Button
                          className="w-100 text-white fw-bold fs-3 login-flow-btn mt-2"
                          type="submit"
                        >
                          Confirm
                        </Button>
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
            <Col
              xl={6}
              lg={12}
              className="text-center text-xl-start align-self-center"
            >
              <img
                src="images/loginFlow-images/newPass.svg"
                alt="login"
                className="w-md-100"
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default ForgetPasswordPage;
